import { useState } from 'react';
import { Button } from 'react-bootstrap';
import {
    TimesheetsTable,
    Pagination,
    FilterTimesheetsOffcanvas,
} from './components';

const MyTimesheets = () => {
    const [setShow] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [filters, setFilters] = useState({
        startDate: null,
        endDate: null,
        status: [],
        tasks: []
    });
    const [pageSize, setPageSize] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const totalItems = 100; // This would come from your API
    const totalPages = Math.ceil(totalItems / pageSize);

    const handleShow = () => setShow(true);
    const handleDeleteShow = () => {};
    const handleMoveOrCopyShow = () => {};
    const handleLogTimeShow = (data) => {
        console.log('Log time:', data);
    };
    const handleHistoryShow = () => {};
    const handleQuickSubtasksShow = () => {};
    const handleEstimateTimeShow = () => {};

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        setShowFilter(false);
        // TODO: Apply filters to data
    };

    return (
        <>
            <div className='c-card-1'>
                <div className='c-card-header-1'>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div>
                            Timesheets
                        </div>
                        <div className='d-flex align-items-center gap-1'>
                            <Button variant='outline-primary' 
                                className='btn-sm me-2 text-nowrap'
                                onClick={() => setShowFilter(true)}
                            >
                                <i className="fas fa-filter me-1"></i>
                                Filter
                            </Button>
                            <Button variant='primary'
                                className='btn-sm text-nowrap'
                            >
                                <i className="fas fa-plus me-1"></i>
                                Add Log
                            </Button>
                        </div>
                    </div>
                </div>
                <FilterTimesheetsOffcanvas
                    show={showFilter}
                    onHide={() => setShowFilter(false)}
                    onSubmit={handleFilterChange}
                    filters={filters}
                />
                <div className='c-card-body-1 p-0'>
                    <TimesheetsTable
                        onEdit={handleShow}
                        onMoveOrCopy={handleMoveOrCopyShow}
                        onLogTime={handleLogTimeShow}
                        onViewHistory={handleHistoryShow}
                        onAddSubtasks={handleQuickSubtasksShow}
                        onView={() => {}} // TODO: Implement view handler
                        onDuplicate={() => {}} // TODO: Implement duplicate handler
                        onDelete={handleDeleteShow}
                        onEstimateTime={handleEstimateTimeShow}
                    />
                </div>
                <div className='c-card-footer-1'>
                    <Pagination
                        pageSize={pageSize}
                        onPageSizeChange={setPageSize}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        totalPages={totalPages}
                        totalItems={totalItems}
                    />
                </div>
            </div>
        </>
    );
};

export default MyTimesheets;